// Copyright 2025, University of Maryland, All Rights Reserved
import type { FC } from 'react'
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardDescription,
} from '@/components/ui'
import { Settings } from 'lucide-react'
import type { NodeAdminViewProps } from '@/core/types'

/**
 * I-9 Compliance admin config view.
 *
 * Phase 1: Minimal stub.
 * Phase 2: Will add configuration for vision model, match thresholds, etc.
 */
export const I9AdminView: FC<NodeAdminViewProps> = () => {
  return (
    <Card data-testid="i9-admin">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Settings className="h-5 w-5" />
          I-9 Compliance Settings
        </CardTitle>
        <CardDescription>
          Configure I-9 verification workflow
        </CardDescription>
      </CardHeader>
      <CardContent>
        <p className="text-sm text-muted-foreground">
          Application settings configured via pipeline nodes. No additional settings required.
        </p>
      </CardContent>
    </Card>
  )
}
